import { GoToPageOptions } from "src/pageDefinitions/goto/page-set";
import { ActionHandler } from "..";
import { completeMainSurvey } from "src/utils/mainSurvey";

type Params = {
  finishedEvent?: string;
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompleteMainSurvey: ActionHandler = async ({
  params,
  store,
  dispatch,
}: {
  params?: Params;
} & GoToPageOptions): Promise<void> => {
  const { surveyAnswers } = store.getState();
  return completeMainSurvey({
    surveyAnswers,
    params,
    dispatch,
  });
};
